'use client';

import type { SourceGroundedReference } from '../../../data/projects/source-grounded-citations';
import {
  SourceGroundedCitationChip,
  type SourceGroundedCitationChipProps,
} from './SourceGroundedCitationChip';

/**
 * The two STATIC app-only inputs the chip cannot resolve for itself: the
 * hover-card shell (shared-UI app code, inverted as a render prop) and the
 * session tabs a citation focuses (session's enum, resolved by the caller so
 * this cluster names no foreign VALUE).
 *
 * `compactCitationsEnabled` is deliberately NOT here. A flag is a hook read, so
 * binding it at the factory would move it to wherever the markdown component map
 * is built — one level above the chip, where it fires for every assistant
 * message whether or not a citation renders. It stays a prop of the component
 * this factory returns, supplied by the markdown tag that mounts it.
 */
export type SourceGroundedCitationBindings = Pick<
  SourceGroundedCitationChipProps,
  'renderPopover' | 'sessionTabs'
>;

export const createSourceGroundedCitationComponent = (
  referencesById: Map<number, SourceGroundedReference>,
  bindings: SourceGroundedCitationBindings
) => {
  const Component = (
    props: Omit<
      SourceGroundedCitationChipProps,
      'referencesById' | keyof SourceGroundedCitationBindings
    >
  ) => (
    <SourceGroundedCitationChip
      {...props}
      {...bindings}
      referencesById={referencesById}
    />
  );
  Component.displayName = 'SourceGroundedCitationChip';
  return Component;
};
